export default __webpack_public_path__ + "static/media/watering-can-background-right.f85837db.svg";